import React from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Link, useNavigate } from "react-router-dom";
import {useState, useContext} from "react"

import { FaArrowAltCircleRight} from "react-icons/fa";
import { AuthContext } from "../UserContext/AuthProvider";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Register = () => {
	const {createUser,updateUserInfo} = useContext(AuthContext)
	const [accept, setAccept] = useState(false);
	const [error, setError] = useState()
	const navigate= useNavigate()

	const handleSubmitBtn = (e) => {
		setAccept(e.target.checked)
	}
	const handleUserCreation = (e) => {
		e.preventDefault()
		createUser(e.target.email.value, e.target.password.value)
		.then(res => {
			const info = {displayName: e.target.username.value, photoURL: e.target.displaypic.value}
			updateUserInfo(info)
			.then(() => {
				e.target.reset()
				setError(null)
				toast.success('Registration success',{
					position: toast.POSITION.TOP_CENTER
				  })
				navigate('/login')
			} )
			.catch(err => setError(err.message))
		})
		.catch(err => setError(err.message))
	}
	return (
		<div className="container py-5">
			<div className="row">
				<div className="col-md-4 py-4 border border-3 offset-md-4 rounded theme_color">
					<Form onSubmit={handleUserCreation} className=" p-3">
						<h2 className="fw-bolder">Create an account!</h2>
						<Form.Group className="mb-3" controlId="formBasicusername">
							<Form.Label>Full name</Form.Label>
							<Form.Control name="username" type="text" placeholder="Enter Full name" />
						</Form.Group>
						<Form.Group className="mb-3" controlId="formBasicEmail">
							<Form.Label>Email address</Form.Label>
							<Form.Control name="email" type="email" placeholder="Enter email" />
						</Form.Group>
						<Form.Group className="mb-3" controlId="formPassword">
							<Form.Label>Password</Form.Label>
							<Form.Control name="password" type="password" placeholder="Enter Password" />
						</Form.Group>
						<Form.Group className="mb-3" controlId="formBasicEmail">
							<Form.Label>Enter Profile Picture Url</Form.Label>
							<Form.Control name="displaypic" type="url" placeholder="Photo url" />
						</Form.Group>
						<Form.Group className="mb-3 ms-4" onClick={handleSubmitBtn} controlId="formBasicCheckbox">
							<Form.Check className="d-inline m-0 p-0" type="checkbox" label={`Agree our `} /> <Link className="d-inline">Terms and Condition</Link>
						</Form.Group>
						<Button disabled={!accept}
							className="w-100 border-0 py-2 fw-bolder bg-black btn"
							type="submit"
						>
							Submit
						</Button>
					</Form>
						{error && <div className="bg-danger fw-bold text-white px-3 rounded py-2">
							{error}
						</div>	}
					<Link
						to="/login"
						className="text-decoration-none text-black fw-bolder"
					>
						Already Registered?{" "}
						<span className="btn tbn-link p-0 m-0 fw-bolder text-decoration-none">
							Login
						</span>{" "}
						<FaArrowAltCircleRight></FaArrowAltCircleRight>{" "}
					</Link>
				</div>
			</div>
		</div>
	);
};

export default Register;
